<template>
  <div class="block-navigation-user">
    <ul class="block-navigation-user__list">
      <li
        v-for="(link, index) in links"
        :key="`${link.link}-${index}`"
      >
        <UtilRouteLink
          v-if="link.url"
          :link="link.url"
          class="block-navigation-user__list-link"
        >
          <IonIcon
            v-if="link.icon"
            :icon-name="link.icon"
            icon-size="var(--icon-size)"
            icon-color="var(--icon-color)"
          />

          {{ link.text }}
        </UtilRouteLink>

        <div
          v-else
          type="button"
          class="block-navigation-user__list-link"
          @click="handleClick(link.action)"
          @keypress="handleClick(link.action)"
        >
          <IonIcon
            v-if="link.icon"
            :icon-name="link.icon"
            icon-size="var(--icon-size)"
            icon-color="var(--icon-color)"
          />

          {{ link.text }}
        </div>
      </li>
    </ul>
  </div>
</template>

<script setup>
defineProps({
    /*
        Styles
    */
    borderRadius: {
        type: String,
        default: 'var(--b-radius--medium)',
    },

    /*
        Content
    */
    links: {
        type: Array,
        default: () => [],
    },
});

/*
    Advanced functions
*/
const handleClick = (action) => {
    switch (action) {
    case 'logout':
        useLogout('/login-magic');
        break;
    default:
        break;
    }
};
</script>

<style lang="scss" scoped>
.block-navigation-user {
    @include fluid('--f-size--button', 15px, 13px, 15px);
    --icon-color: var(--c-primary-500);
    --icon-size: 16px;
    position: relative;
    display: inline-flex;
    padding: 20px 0;
    border-radius: var(--b-radius-200);
    background-color: var(--c-white);
    color: var(--c-primary-500);
    font-family: var(--f-family--primary);
    font-size: var(--f-size--button);
    font-weight: var(--f-weight--700);

    @include tablet{
        padding: 15px 20px;
        background-color: var(--c-primary-500);
        color: var(--c-white);
        --icon-color: var(--c-white);
    }

    ::v-deep(.ion-icon__svg) {
        width: 20px;
        @include fluid('width', 15px, 22px, 22px);
    }

    &:after {
        @include fluid('right', 13px, 13px, 17.5px);

        position: absolute;
        top: 1px;
        display: none;
        width: 18px;
        height: 18px;
        border-radius: 2px;
        background-color: var(--c-white);
        content: '';
        pointer-events: none;
        transform: rotate(45deg);
        transform-origin: top right;

        @include tablet {
            display: block;
            background-color: var(--c-primary-500);
        }
    }
}

.block-navigation-user__list {
    display: flex;
    flex-direction: column;

    align-items: flex-end;
    row-gap: 20px;

    @include tablet {
        align-items: flex-start;
    }
}

.block-navigation-user__list-link {
    display: flex;
    align-items: center;
    column-gap: 10px;
}
</style>
